import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedPushApi } from '@/features/api/hooks/shared-push/useSharedPushApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetPushCategorySettings = () => {
  const api = useSharedPushApi();
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: [API_CACHE_KEYS.PUSH_CATEGORIES],
    queryFn: () => api.getPushCategoryUserSettings(),
    enabled: isAuthenticated
  });
};
